module.exports = __webpack_public_path__ + "static/media/real-estate.6b693aec.png";